/* eslint-disable no-nested-ternary */
import React from "react";
import { useFullUser } from "auth/useUser.js";

import useTranslation from "next-translate/useTranslation";
import { useRenders, getConvertedDistanceAlertThreshold } from "modules/utils";

import SwitchGroup from "components/Switch/SwitchGroup";
import CustomInput from "components/Inputs/CustomInput";
import { makeStyles } from "tss-react/mui";

import {
  getDistanceAlertThresholdOptions,
  PriceAlertInputs,
} from "./SettingsSection";

import {
  dashboardLabel,
  helperText,
} from "../../assets/jss/nextjs-material-kit-pro";

const useStyles = makeStyles()({
  dashboardLabel,
  helperText,
  zeroMargin: { margin: 0 },
});

export default function ItemOptions(props) {
  const {
    athlete,
    productEntry,
    supportsShoes,
    retired,
    localeCurrency,
    disabled,
    customHandleChange,
    useCustomOnBlurOnChange,
    doNotPreventSelecting,
    controlledLoadingState,
    controlled,
    thresholds,
    fixedMinWidth,
    showCurrentPrice,
  } = props;

  const [user, { handleUpdateUser, isUpdating, isUpdatingError }] =
    useFullUser();

  const { classes, cx } = useStyles();

  const { t } = useTranslation();
  useRenders("");

  let productId,
    distanceAlertThreshold,
    distanceAlerts,
    priceAlertThreshold,
    familyPriceAlerts,
    priceAlerts;

  if (productEntry?.settings) {
    ({
      settings: {
        distanceAlertThreshold,
        distanceAlerts,
        priceAlertThreshold,
        priceAlerts,
        familyPriceAlerts,
        //   newModelAlerts,
        //   newReviewAlerts,
        //   shoeSize,
      },
    } = productEntry);
  }
  if (productEntry.product) {
    ({
      product: { databaseId: productId },
    } = productEntry);
  }

  const {
    databaseId,
    communicationPreferences: {
      measurementPreference,
      distanceAlertThreshold: athleteDistanceAlertThreshold,
    },
  } = athlete;
  // TODO: Currency should be set at the user level and appropriate inputAdornment used
  const type = "athlete";
  const target = productEntry?.settings;

  const athleteProductUpdatesItem = { productId, updates: {} };
  const additionalVars = { athleteProductUpdates: [athleteProductUpdatesItem] };

  const updateSettingsProps = {
    target,
    additionalVars,
    addResultToAdditionalVars: true,
    additionalVarsTargetPath: athleteProductUpdatesItem.updates,
  };

  const options = [
    {
      name: "priceAlerts",
      ...updateSettingsProps,
      paths: ["priceAlerts"],
      label: t("product:priceAlerts"),
      isSelected: priceAlerts,
      helperText: t("product:priceAlertsHelperText"),
      disabled,
      followOnInput: (
        <PriceAlertInputs
          fixedMinWidth={fixedMinWidth}
          isUpdating={isUpdating}
          controlled={controlled}
          thresholds={thresholds}
          showCurrentPrice={productEntry?.product && showCurrentPrice}
          label={t("product:threshold")}
          disabled={
            retired ||
            isUpdating ||
            disabled ||
            controlledLoadingState ||
            !productEntry?.product
          }
          onBlur={(event, setLoadingState) =>
            customHandleChange
              ? customHandleChange({
                  name: "priceAlertThreshold",
                  target: event.target,
                })
              : handleUpdateUser({
                  ...updateSettingsProps,
                  type,
                  isUpdating,
                  event,
                  setLoadingState,
                  paths: ["priceAlertThreshold"],
                })
          }
          value={priceAlertThreshold}
          familyPriceAlerts={familyPriceAlerts}
          localeCurrency={localeCurrency}
          controlledLoadingState={controlledLoadingState}
          useCustomOnBlurOnChange={useCustomOnBlurOnChange}
          onCheckboxChange={(event, setLoadingState) =>
            customHandleChange
              ? customHandleChange({
                  name: "familyPriceAlerts",
                  target: event.target,
                  type: "checkbox",
                  setLoadingState,
                })
              : handleUpdateUser({
                  ...updateSettingsProps,
                  type,
                  setLoadingState,
                  event,
                  name: "familyPriceAlerts",
                  paths: ["familyPriceAlerts"],
                })
          }
        />
      ),
    },
  ];

  if (supportsShoes && productEntry.usageStatus !== "watching") {
    options.unshift(
      getDistanceAlertThresholdOptions({
        measurementPreference,
        distanceAlerts,
        distanceAlertThreshold,
        isUpdating,
        isUpdatingError,
        handleUpdateUser,
        disabled: retired,
        t,
        type,
        otherProps: updateSettingsProps,
        placeholderValue: distanceAlertThreshold
          ? null
          : athleteDistanceAlertThreshold,
        customOnChange:
          customHandleChange &&
          ((event) =>
            customHandleChange({
              name: "distanceAlertThreshold",
              target: event.target,
              user,
            })),
      })
    );
  }

  return (
    <SwitchGroup
      preventSelecting={
        !doNotPreventSelecting && !athlete.communicationPreferences.email
      }
      isPreventedPopUpKey="email"
      shouldValidate
      labelClasses={classes.dashboardLabel}
      helperTextClasses={classes.helperText}
      disabled={isUpdating || disabled}
      customHandleChange={
        customHandleChange ? customHandleChange : handleUpdateUser
      }
      isUpdating={isUpdating}
      isUpdatingError={isUpdatingError}
      type={type}
      id={databaseId}
      controlled
      options={options}
    />
  );
}
